import { AwardMatch as AwardMatchComponent } from './AwardMatch.component'
import { connector } from './AwardMatch.connector'

export const AwardMatch = connector(AwardMatchComponent);
